import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=1005e12f&scoped=true&"
var script = {}
import style0 from "./FooterSection.vue?vue&type=style&index=0&id=1005e12f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005e12f",
  null
  
)

export default component.exports